package com.dotdrives.web.pages.settings

import com.dotdrives.design.DotButtonVariant
import com.dotdrives.web.ui.DotBanner
import com.dotdrives.web.ui.DotButton
import com.dotdrives.web.ui.useDialogFocus
import react.FC
import react.Props
import react.dom.aria.AriaRole
import react.dom.html.ReactHTML.div
import web.cssom.ClassName
import web.dom.ElementId

external interface SettingsConfirmDialogProps : Props {
    var title: String
    var message: String
    var action: String
    var busy: Boolean
    var error: String?
    var onConfirm: () -> Unit
    var onClose: () -> Unit
}

val SettingsConfirmDialog = FC<SettingsConfirmDialogProps> { props ->
    useDialogFocus(true, "settings-management-confirm", onClose = { if (!props.busy) props.onClose() })
    div {
        className = ClassName("settings-dialog-backdrop")
        onClick = { if (!props.busy) props.onClose() }
        div {
            id = "settings-management-confirm".unsafeCast<ElementId>()
            className = ClassName("settings-dialog settings-management-dialog")
            role = "dialog".unsafeCast<AriaRole>()
            ariaModal = true
            ariaLabel = props.title
            onClick = { it.stopPropagation() }
            div { className = ClassName("settings-dialog-title"); +props.title }
            div { className = ClassName("settings-section-subtitle"); +props.message }
            props.error?.let { DotBanner { message = it } }
            div {
                className = ClassName("settings-dialog-actions")
                DotButton { text = "Cancel"; variant = DotButtonVariant.Secondary; enabled = !props.busy; onClick = props.onClose }
                DotButton { text = props.action; loading = props.busy; enabled = !props.busy; onClick = props.onConfirm }
            }
        }
    }
}
